import { render } from "./espece.vue?vue&type=template&id=cb1181ea&scoped=true"
import script from "./espece.vue?vue&type=script&lang=js"
export * from "./espece.vue?vue&type=script&lang=js"

import "./espece.vue?vue&type=style&index=0&id=cb1181ea&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb1181ea"]])

export default __exports__